module.exports = __webpack_public_path__ + "img/fast_payouts.a5d284cc.png";